"use strict";

var _interopRequireWildcard = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
var product = _interopRequireWildcard(require("@/api/product"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _imeiReceive = require("@/api/imei-receive");
var _RemovedImeiByAgency = _interopRequireDefault(require("./components/RemovedImeiByAgency.vue"));
var _moment = _interopRequireDefault(require("moment"));
var _ReceiveImeiHistory = _interopRequireDefault(require("./components/ReceiveImeiHistory.vue"));
var _enum = require("@/types/enum");
var _ReceiveImeiModal = _interopRequireDefault(require("./components/ReceiveImeiModal.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    ImeiByAgency: _RemovedImeiByAgency.default,
    ReceiveImeiHistory: _ReceiveImeiHistory.default,
    ReceiveImeiModal: _ReceiveImeiModal.default
  },
  created: function created() {},
  data: function data() {
    return {
      loadingButtonExcel: false,
      objData: {
        imei: ""
      },
      loadingSubmit: false,
      loadingRemove: false,
      ImeiRequestStatus: _enum.ImeiRequestStatus,
      totalRecord: 0,
      arrDevice: [],
      tableData: [],
      total: 0,
      data: [],
      successImeis: [],
      failImeis: [],
      expiredImeis: [],
      listQuery: {
        page: 1,
        limit: 10,
        status: "REMOVED"
      },
      tableLoading: false
    };
  },
  watch: {
    "objData.imei": function objDataImei(val) {
      var arr = val.split("\n");
      var res = arr.filter(function (item) {
        if (item) return item;
      });
      this.totalRecord = res.length;
    }
  },
  methods: {
    resetForm: function resetForm() {
      this.successImeis = [];
      this.data = [];
      this.failImeis = [];
    },
    handleSubmitOk: function handleSubmitOk() {
      this.resetForm();
      this.$refs.history.fetchData();
    },
    handleRemove: function handleRemove() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var imeis;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              imeis = _this.successImeis.map(function (e) {
                return e.imei;
              });
              _this.$refs.ReceiveImeiModal.handleOpen(imeis);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleReceive: function handleReceive() {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var imeis, res, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              imeis = _this2.objData.imei.split("\n").filter(function (e) {
                return e;
              });
              _this2.loadingSubmit = true;
              _context2.prev = 2;
              _context2.next = 5;
              return _imeiReceive.imeiReceiveApi.check({
                imeis: imeis
              });
            case 5:
              res = _context2.sent;
              _this2.data = res.data;
              data = res.data;
              _this2.successImeis = data.filter(function (e) {
                return e.status == _enum.ImeiRequestStatus.valid;
              });
              _this2.failImeis = data.filter(function (e) {
                return e.status == _enum.ImeiRequestStatus.invalid;
              });
              _this2.expiredImeis = data.filter(function (e) {
                return e.status == _enum.ImeiRequestStatus.expired;
              });
            case 11:
              _context2.prev = 11;
              _this2.loadingSubmit = false;
              return _context2.finish(11);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2,, 11, 14]]);
      }))();
    }
  }
};